import { RootState } from '@/shared/store'

import { runsheetUnassignedTablesAdapter } from '../adapters/runsheetUnassignedTablesAdapter'

export const runsheetUnassignedTablesSelector = runsheetUnassignedTablesAdapter.getSelectors<RootState>(
  (state) => state.runsheetUnassignedTables,
)
